//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadFile from '../../../../shared-components/upload/UploadFile';
import RegisterForm from '../../../../shared-components/generico/RegisterForm';
import mdChipsAutocomplete from '../../../../shared-components/chipsautocomplete/mdChipsAutocomplete';

import { copyObject } from '../../../../common/functions/helpers';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'TipoOrcamentoSideColumn',
  props: {
    fetchFunction: Function,
    prepareResponseData: Function,
  },
  data() {
    return {
      chipsTipoInvestimento: [],
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
      disableButton: false,
      tipoOrcamento: {
        indAtivo: true,
        idExterno: '',
        nome: '',
        tiposInvestimento: [],
      },
      originalTipoOrcamento: null,
      source: [],
    };
  },
  computed: {
    ...generateComputed('Tipo Orc', [
      'canAccessCRUD',
    ]),
    importUrl() {
      return `${basePath}/importacao?tipo_importacao`;
    },
  },
  components: {
    mdChipsAutocomplete,
    RegisterForm,
    UploadFile,
  },
  methods: {
    addTipoInvestimentoChip(value) {
      this.chipsTipoInvestimento = value.map(el => el.id);

      this.tipoOrcamento.tiposInvestimento = {};
      this.tipoOrcamento.tiposInvestimento = value;
    },
    cancel() {
      this.$emit('SIDECOLUMN_CANCEL_ACTION');
      this.clearForm();
    },
    clearForm() {
      this.tipoOrcamento = copyObject(this.originalTipoOrcamento);
      setTimeout(() => {
        this.fields.reset();
        this.errors.clear();
        this.$refs.containerIdExterno.inputLength = 0;
        this.$refs.containerOrcamento.inputLength = 0;
        this.source = [];
        this.$refs.tipoLinhaOrcamento.selectedChips = [];
        this.chipsTipoInvestimento = [];
      }, 1E2);
    },
    cleantipoInvestimento() {
      this.tipoOrcamento.tiposInvestimento = [];
      this.tipoOrcamento.tipoInvestimento = '';
    },
    closeDialog(ref, cb) {
      this.$refs[ref].close();
      this.$refs[ref].active = false;
      if (cb) {
        cb();
      }
    },
    openDialog(ref) {
      this.$refs[ref].open();
      this.$refs[ref].active = true;
    },
    openSaveDialog(ref, from) {
      this.$validator.validateAll()
        .then((isValid) => {
          if (!isValid) {
            return;
          }
          const content = this.$t('message.salvar_novo_tipoOrcamento');
          this.setDialogContent(content, this.save, from || this.dialog.from);

          this.openDialog(ref || this.dialog.ref);
        });
    },
    save(obj) {
      const objTipoOrcamento = Object.assign({}, obj || this.tipoOrcamento);
      objTipoOrcamento.descricao = objTipoOrcamento.nome;
      this.$emit('SIDECOLUMN_SAVE_ACTION', objTipoOrcamento, this.clearForm);
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    uploadError(file, msg) {
      this.$toast.create(msg || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    uploadSuccess() {
      this.$toast.create(this.$t('message.importado_em_breve_sera_processado'), 'snack', 8E3);
    },
  },
  mounted() {
    this.originalTipoOrcamento = copyObject(this.tipoOrcamento);
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/tipo-orcamento/SideColumn.vue?vue&type=script&lang=js&